var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Account")]),(_vm.$store.state.isAuthenticated)?_c('div',[_vm._v(" Logged in "+_vm._s(_vm.$store.state.user.email)+" ")]):_c('div',[_vm._v("Not logged in")])])}
var staticRenderFns = []

export { render, staticRenderFns }